import React from 'react';

type Step2Props = {
    step: number,
    setStep: (step: number) => void,
    maxStep: number,
}

function Step2({step, setStep, maxStep}: Step2Props) {
    const onCloseClick = () => {
        setStep(step + 1)

        localStorage.setItem('age_access', '1')
        sessionStorage.setItem("age_access", "1")
    }
    
    return (
        <div className="age-access-inner">
            <div className="age-access__text">
                <div className="text-dark font-medium dark:font-light text-xl dark:text-textDarkLightGray
                             mb-5 ">
                                {`${step} / ${maxStep}`}
                </div>
                <div className="text-dark font-medium dark:font-extralight text-lg dark:text-textDarkLightGray
                             mb-4 text-center">
                    Заказываете для <b>Себя</b> или для <b>Бизнеса?</b></div>
            </div>
            <div className="age-access__buttons flex flex-row justify-between">
                <a href="#" className="age-access__button age-access__yes link_red_button arcticmodal-close
                             border-greenButton border-2 px-3.5 py-2 rounded-md block w-2/5 mr-3 md:text-sm text-xs
                             font-medium text-center text-greenButton dark:border-none dark:bg-grayButton
                             dark:font-light shadow-lg dark:text-white"
                   data-option="1" data-auth="false" onClick={onCloseClick}>Для себя</a>
                <a href="https://oshisha.cc?referer=retail/" className="link_red_button text-center
                            border-light-red border-2 md:px-9 px-4 py-2 rounded-lg block w-3/5 text-light-red font-medium
                            dark:border-none dark:bg-dark dark:font-light dark:text-white shadow-lg md:text-sm text-xs"
                   rel="nofollow">Для бизнеса</a>
            </div>
        </div>
    );
}

export default Step2;